import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedPercentage',
  pure: false,
})
export class LocalizedPercentagePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string | number): string | null {
    if (value === null || value === undefined) return null;

    const percentValue = typeof value === 'string' ? parseFloat(value) : value;

    //Possible value from parseFloat
    if (isNaN(percentValue)) return null;

    let percentDisplayValue = Number.isInteger(percentValue) ? percentValue.toFixed(0) : percentValue.toFixed(2);

    if (this.translateService.currentLang === 'de') {
      percentDisplayValue = percentDisplayValue.replace('.', ',');
    }

    return percentDisplayValue + '%';
  }
}
